import { render } from "./TheTopHeaderNotificationsHeader.vue?vue&type=template&id=2e41dc01&scoped=true"
import script from "./TheTopHeaderNotificationsHeader.vue?vue&type=script&lang=js"
export * from "./TheTopHeaderNotificationsHeader.vue?vue&type=script&lang=js"

import "./TheTopHeaderNotificationsHeader.vue?vue&type=style&index=0&id=2e41dc01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e41dc01"]])

export default __exports__